/**
 * 全局事件总线
 * 用于跨组件通信
 */

type EventHandler = (...args: any[]) => void;

class EventBus {
  private events: Record<string, EventHandler[]> = {};

  /**
   * 订阅事件
   */
  on(event: string, handler: EventHandler): () => void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(handler);

    // 返回取消订阅函数
    return () => this.off(event, handler);
  }

  /**
   * 取消订阅事件
   */
  off(event: string, handler: EventHandler): void {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(h => h !== handler);
  }

  /**
   * 触发事件
   */
  emit(event: string, ...args: any[]): void {
    if (!this.events[event]) return;
    this.events[event].forEach(handler => {
      handler(...args);
    });
  }

  /**
   * 清空所有事件
   */
  clear(): void {
    this.events = {};
  }

  /**
   * 清空指定事件的所有监听器
   */
  clearEvent(event: string): void {
    delete this.events[event];
  }
}

// 导出单例
export const eventBus = new EventBus();

export default eventBus;
